import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { EPaymentGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

// https://docs.google.com/spreadsheets/u/2/d/1oxESW-0Ne7WtP7gKejV6CJYSv-Q9ssFDC8MY1_chDT0/edit

export type TSendAnalytics = (label: string, isFamily?: boolean, name?: string) => void;

type TUseSendSpaceAnalytics = (props: { isMarketingPromo: boolean; skipAnalytics: boolean }) => TSendAnalytics;

export enum SpaceButtonAnalyticsName {
    SPACE = 'add_space',
    FAMILY = 'family',
    SUBS = 'subs',
    CYBER_MONDAY_2025 = 'cyber_monday_mnz',
    MAY_PROMO_2025 = 'promo_action_ms_june25_mnz',
    MARCH_PROMO_2026 = 'march_promo_2026',
    SUMMER_SALE_2026 = 'summer_sale_2026',
}

export const useSendSpaceAnalytics: TUseSendSpaceAnalytics = ({ isMarketingPromo, skipAnalytics }) => {
    const remaining = useSelector(UserQuotaSelectors.getRemaining);
    const total = useSelector(UserQuotaSelectors.getTotal);

    let action = EPaymentGa.space;

    if (isMarketingPromo) {
        action = EPaymentGa.spaceAction;
    }

    return useCallback(
        (label: string, isFamily = false, name?: string) => {
            if (skipAnalytics) {
                return;
            }

            sendPaymentGa({
                action,
                label,
                size_quota: total?.original,
                free_quota: remaining?.original,
                group: 'b',
                ...(isFamily && { paid_user_invite: true }),
                ...(name && { name }),
            });
        },
        [action, remaining?.original, skipAnalytics, total?.original]
    );
};
